module.exports = __webpack_public_path__ + "img/5-Editor-Saving.22468c6e.gif";